import cs from 'classnames'
import React from 'react'

import { markdownify } from '../../../utils'
import { CheckList } from '../../atoms/Lists'
import ButtonActions, { ButtonActionItem } from '../ButtonActions'
import * as styles from './style.module.css'

type CtaBlockPropType = {
  title: string
  description: string
  listDescription?: string
  list: string[]
  threeColumns?: boolean
  cta?: {
    title: string
    subtitle: string
    actions: ButtonActionItem[]
  }
  children?: React.ReactNode
}

export default function CtaBlock({
  title,
  description,
  listDescription,
  list,
  threeColumns,
  cta,
  children
}: CtaBlockPropType) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionDescription}>
        <h2 className={styles.sectionTitle}>{title}</h2>
        <p className={styles.description}>{markdownify(description)}</p>
        {listDescription && (
          <p className={styles.description}>{markdownify(listDescription)}</p>
        )}
        <div className={styles.checkList}>
          <CheckList
            items={list}
            className={cs(styles.item, threeColumns && styles.threeColumns)}
          />
        </div>
      </div>
      {cta && (
        <div>
          <div className={styles.explore}>
            <div className={styles.title}>{cta.title}</div>
            <div className={styles.subtitle}>{markdownify(cta.subtitle)}</div>
            <ButtonActions
              actions={cta.actions}
              uniformButtons={false}
              secondaryButton={false}
            />
          </div>
        </div>
      )}
      {children && <div>{children}</div>}
    </div>
  )
}
